import React from "react";
import Item from "../../../../myTask/Worklog/components/Item";
import ShowWorklog from "./ShowWorklog";
const WorklogHistory = ({ worklog, boardName }) => {
  return <>{<ShowWorklog worklog={worklog} boardName={boardName} />}</>;
};

export default React.memo(WorklogHistory);
